import PropTypes from "prop-types";
import { Component } from "react";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { findAnswer, isAnswered } from "../../../../utils/QuestionUtils";
import ValidatorUtils from "../../../../utils/ValidatorUtils";
import QuestionHeader from "./QuestionHeader";
import RichTextRenderer from "./renderer/RichTextRenderer";

/**
 * Comment question component for survey-view.
 */
class CommentQuestion extends Component {

  render() {
    const { question, questionAnswer, validation, setQuestionAnswer, row, column, validateCommentAnswer, disabled } =
      this.props;
    const collection = questionAnswer.answers;
    const answer = findAnswer(collection, {
      row,
      column
    });

    const initialTextLength = answer?.value ? ValidatorUtils.getTextLength(answer.value) : null;
    
    const answered = isAnswered(question, questionAnswer);
    return (
      <Row>
        <Col sm={12} md={12} lg={12}>
          <QuestionHeader
            question={question}
            answered={answered}
            validation={validation}
            initialTextLength={initialTextLength}
          >
            <RichTextRenderer
              disabled={disabled}
              question={question}
              collection={collection}
              setQuestionAnswer={setQuestionAnswer}
              validateCommentAnswer={validateCommentAnswer}
              isIncomplete={!answered && question.isRequired}
            />
          </QuestionHeader>
        </Col>
      </Row>
    );
  }
}

CommentQuestion.propTypes = {
  disabled: PropTypes.bool,
  question: PropTypes.object,
  questionAnswer: PropTypes.object,
  validation: PropTypes.array,
  hasAnswer: PropTypes.func,
  setQuestionAnswer: PropTypes.func,
  textValue: PropTypes.string,
  validateCommentAnswer: PropTypes.bool,
  row: PropTypes.string,
  column: PropTypes.string
};

export default CommentQuestion;
